import { NgModule } from '@angular/core';
import { ElListComponent, ElListItemComponent } from './list.component';
import { ElListPageTrackerDirective } from './list-page-tracker.directive';
import { ElInfiniteListDirective } from './infinite-list.directive';

const components = [
  ElListComponent,
  ElListItemComponent,
  ElListPageTrackerDirective,
  ElInfiniteListDirective,
];

@NgModule({
  declarations: components,
  exports: components,
})
export class ElListModule {}
